import { token } from "./stores";

export interface IApiClient {
    get(path: string, params?: any): Promise<any>;
    post(path: string, params: any): Promise<any>;
    put(path: string, params: any): Promise<any>;
    delete(path: string, params: any): Promise<any>;
}

type HttpVerb = "get" | "post" | "put" | "delete";

class ServerBase implements IApiClient {
    private host: string;
    private headers: any;

    constructor(host: string) {
        this.host = host;
        this.headers = {
            "Content-Type": "application/json"
        };
        token.subscribe(value => {
            if (value != null && value.length > 0) {
                this.headers["Authorization"] = "Bearer " + value;
            } else {
                this.headers["Authorization"] = null;
            }
        });
    }

    public async get(path: string, data?: any): Promise<any> {
        return await this.httpRequest("get", path, data);
    }

    public async delete(path: string, data?: any): Promise<any> {
        return await this.httpRequest("delete", path, data);
    }

    public async post(path: string, data: any): Promise<any> {
        return await this.httpRequest("post", path, data);
    }

    public async put(path: string, data: any): Promise<any> {
        return await this.httpRequest("put", path, data);
    }

    private async httpRequest(httpverb: HttpVerb, urlpath: string, data?: any): Promise<any> {
        try {
            let url = this.host + urlpath;
            console.log(httpverb, url);
            const options: any = {
                method: httpverb.toUpperCase(),
                headers: this.headers
            }
            if (httpverb == "put" || httpverb == "post") {
                options.body = JSON.stringify(data)
            } else {
                let u = new URLSearchParams(data).toString();
                if (u.length > 0) {
                    url += "?" + u;
                    console.log(httpverb, url);
                }
            }
            const res = await fetch(url, options);
            if (res.status < 200 || res.status >= 300) {
                throw new Error(await res.text());
            }
            return res.json();
        } catch (error) {
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                console.log(error.response.data);
                console.log(error.response.status);
                console.log(error.response.headers);
                throw new Error(error.response.data);
            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                // http.ClientRequest in node.js
                console.log(error.request);
                throw new Error("Napaka pri komunikaciji");
            } else {
                // Something happened in setting up the request that triggered an Error
                console.log("Error", error.message);
                throw new Error(error.message);
            }
        }
    }
}

/** Factory function for REST client. Uses the Axios library internally.
 * This way we expose Axios interfaces but leave the implementation open to mocking.
 */
export function create(): IApiClient {
    return new ServerBase("");
}
